module.exports = __webpack_public_path__ + "media/images/features/support/thumb-voice-2-156c597dd7c59f3e6f91cc760a1c8074.jpg";